const firebaseProjectId = process.env.VUE_APP_FIREBASE_PROJECTID;
const firebaseStorageBucket = process.env.VUE_APP_FIREBASE_STORAGEBUCKET ||
  ('development' === process.env.NODE_ENV && firebaseProjectId
    ? `${firebaseProjectId}.appspot.com`
    : undefined);

export default {
  API_PDF_EXPORT_BASE       : process.env.VUE_APP_API_PDF_EXPORT_BASE,
  API_SIGN_SITELOG          : process.env.VUE_APP_API_SIGN_SITELOG,
  FIREBASE_APIKEY           : process.env.VUE_APP_FIREBASE_APIKEY,
  FIREBASE_AUTHDOMAIN       : process.env.VUE_APP_FIREASE_AUTHDOMAIN,
  FIREBASE_DATABASEURL      : process.env.VUE_APP_FIREBASE_DATABASEURL,
  FIREBASE_PROJECTID        : firebaseProjectId,
  FIREBASE_STORAGEBUCKET    : firebaseStorageBucket,
  FIREBASE_MESSAGINGSENDERID: process.env.VUE_APP_FIREBASE_MESSAGINGSENDERID,
  FIREBASE_APPID            : process.env.VUE_APP_FIREBASE_APPID,
  FIREBASE_APPCHECK_TOKEN   : process.env.VUE_APP_FIREBASE_APPCHECK_TOKEN,

  // Vue.js specific configs
  PERFORMANCE: process.env.VUE_APP_PERFORMANCE || false,
}
